// extracted by mini-css-extract-plugin
export default {"btn":"Attach_btn__hpjh1","list":"Attach_list__KzlKa","delete":"Attach_delete__eXT4R","link":"Attach_link__TbP07","title":"Attach_title__-2e1n","fileName":"Attach_fileName__uuw7R"};